/* TT-BOAT-QUIZ - Help me choose (sections/tt-boat-quiz.liquid). Five questions, one per screen,
   scored in the browser against the lineup the section rendered, ending on a best match and a
   runner-up. Answers ride in the hash (#q=lakes.roof.pedal.solo.mid) so a result can be shared and
   the back button steps through the questions.

   SCORING. A fit the boat cannot meet is a large negative rather than a filter, so every set of
   answers still ends on two boats: the closest fits win when the answers pull against each other
   (a trunk and a paddle-only boat, say: the inflatable still wins, since the car decides). */
(function () {
  var root = document.querySelector('[data-quiz]');
  if (!root) return;
  var dataEl = root.querySelector('[data-quiz-data]');
  var stage = root.querySelector('[data-quiz-stage]');
  if (!dataEl || !stage) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { stage.innerHTML = '<span class="tt-missing">Boat finder data did not parse.</span>'; return; }
  var Q = D.questions;
  var boats = D.boats.filter(function (b) { return b.found; });

  var NO = -40;
  function score(b, a) {
    var s = 0;
    // 1. Where: every boat is at home on a lake; length suits the open water, short hulls the rivers.
    // The first water a boat lists is the one it is best at, worth a point more (Terra: open water).
    if (b.water.indexOf(a.water) > -1) s += b.water[0] === a.water ? 4 : 3;
    // 2. Getting it there: the car decides.
    if (a.haul === 'truck') s += b.build === 'rigid' ? 2 : 0;
    if (a.haul === 'roof') s += b.build === 'air' ? 2 : (b.ft <= 12 ? 2 : -3);
    if (a.haul === 'trunk') s += b.build === 'air' ? 20 : NO;
    // Lifting it: the dog food test. Easily changes nothing, so a strong buyer still gets the Pro
    // series; the others favour the lighter boats. Rigged weights, the number the specs show
    // (Josh, 2026-10-20): Highlanders 37-61 lb, Maleo 100 / Pacifica 115 65-69, Outpost 100 /
    // Terra / Maleo 120 76-77, the rest heavier.
    if (a.lift === 'effort' && b.lb) s += b.lb <= 69 ? 2 : b.lb <= 77 ? 1 : -1;
    if (a.lift === 'no' && b.lb) s += b.lb <= 61 ? 5 : b.lb <= 69 ? 2 : b.lb <= 77 ? 0 : -2;
    // 3. Power.
    if (a.power === 'pedal') s += b.power === 'pedal' ? 3 : NO;
    if (a.power === 'paddle') s += b.power === 'paddle' ? 14 : 0;
    if (a.power === 'both') s += b.power === 'pedal' ? 4 : 0;
    // Motor: the Pro series has the bow motor mount (Outpost and Terra product templates).
    if (a.power === 'motor') s += b.rig === 'pro' ? 10 : -8;
    // 4. Seats.
    if (a.seats === 'solo') s += b.seats === 'solo' ? 2 : NO;
    if (a.seats === 'tandem') s += b.seats === 'tandem' ? 6 : NO;
    if (a.seats === 'both') s += b.seats === 'tandem' ? 4 : 1;
    // 5. Rigging.
    var rig = { pro: { pro: 5, mid: 2, simple: 0 }, mid: { pro: 2, mid: 3, simple: 2 }, simple: { pro: 0, mid: 2, simple: 4 } };
    s += rig[a.rig][b.rig];
    return s;
  }

  // Why it fits: one line per answer the boat actually meets, in the visitor's own terms.
  function reasons(b, a) {
    var r = [];
    if (a.water === 'lakes') r.push('At home on lakes and ponds');
    if (a.water === 'rivers' && b.water.indexOf('rivers') > -1) r.push('Short enough to turn easily on rivers');
    if (a.water === 'bays' && b.water.indexOf('bays') > -1) r.push('Length to hold a line on bays and open water');
    if (a.haul === 'trunk' && b.build === 'air') r.push('Packs into its bag and rides in your trunk');
    if (a.haul === 'roof' && b.build === 'air') r.push('No roof rack needed: it packs into its bag');
    if (a.haul === 'roof' && b.build === 'rigid' && b.ft <= 12) r.push('A roof-rack length at ' + feet(b.ft));
    if (a.haul === 'truck' && b.build === 'rigid') r.push('Rides in a truck bed or on a trailer');
    if ((a.lift === 'effort' || a.lift === 'no') && b.lb && b.lb <= 69) r.push('Just ' + b.lb + ' lb rigged, easy to lift on your own');
    if (a.power === 'pedal' && b.power === 'pedal') r.push('Takes the Traverse pedal drive');
    if (a.power === 'both' && b.power === 'pedal') r.push('Pedal with the Traverse drive, or paddle it');
    if (a.power === 'paddle' && b.power === 'paddle') r.push('A paddle kayak: nothing to set up');
    if (a.power === 'motor' && b.rig === 'pro') r.push('Bow motor mount for a trolling motor');
    if (a.seats === 'solo' && b.seats === 'solo') r.push('Built for one');
    if ((a.seats === 'tandem' || a.seats === 'both') && b.seats === 'tandem') r.push('Seats two');
    if (a.rig === 'pro' && b.rig === 'pro') r.push('Pro series: power plates and room for electronics');
    if (a.rig === 'mid' && b.rig !== 'simple') r.push('Room for a few rods and a day of gear');
    if (a.rig === 'simple' && b.rig === 'simple') r.push('Simple to own and quick to launch');
    return r.slice(0, 5);
  }
  function feet(ft) { var f = Math.floor(ft), i = Math.round((ft - f) * 12); return f + '′' + (i ? ' ' + i + '″' : ''); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  var answers = [];
  function readHash() {
    var m = location.hash.match(/^#q=([a-z.]*)$/);
    if (!m) return [];
    var out = [];
    m[1].split('.').some(function (id, i) {
      if (!Q[i] || !Q[i].a.some(function (o) { return o.id === id; })) return true;
      out.push(id);
      return false;
    });
    return out;
  }
  function go(list, replace) {
    var h = list.length ? '#q=' + list.join('.') : location.pathname + location.search;
    if (replace) history.replaceState(null, '', list.length ? h : location.pathname + location.search);
    else history.pushState(null, '', h);
    answers = list;
    render(true);
  }

  function render(focus) {
    if (answers.length < Q.length) renderQuestion(answers.length);
    else renderResult();
    if (focus) {
      var h = stage.querySelector('[data-quiz-focus]');
      if (h) h.focus({ preventScroll: true });
      var top = root.getBoundingClientRect().top;
      if (top < 0) root.scrollIntoView({ block: 'start' });
    }
  }

  function dots(n) {
    var s = '<ol class="tt-quiz__dots" aria-hidden="true">';
    for (var i = 0; i < Q.length; i++) s += '<li class="' + (i < n ? 'is-done' : i === n ? 'is-on' : '') + '"></li>';
    return s + '</ol>';
  }

  function renderQuestion(i) {
    var q = Q[i];
    var h = '<div class="tt-quiz__q">' + dots(i);
    h += '<p class="tt-quiz__count">Question ' + (i + 1) + ' of ' + Q.length + '</p>';
    h += '<h2 class="tt-quiz__ask" tabindex="-1" data-quiz-focus>' + esc(q.q) + '</h2><div class="tt-quiz__opts">';
    /* An answer with a picture (the brand's data snippet) becomes a card: the picture, then the words.
       Small files, lazy, and the next question's pictures are fetched while this one is read. */
    var pics = q.a.some(function (o) { return o.img || o.miss; });
    q.a.forEach(function (o) {
      var pic = '';
      if (o.img) pic = '<span class="tt-quiz__opt-pic' + (o.fit === 'contain' ? ' is-contain' : '') + '"><img src="' + esc(o.img) + '" srcset="' + esc(o.set || '') + '" sizes="(min-width: 750px) 240px, 112px" width="480" height="320" loading="lazy" decoding="async" alt=""></span>';
      else if (o.miss) pic = '<span class="tt-quiz__opt-pic"><span class="tt-missing">No file ' + esc(o.miss) + ' in the store\'s Files.</span></span>';
      else if (pics) pic = '<span class="tt-quiz__opt-pic"></span>';
      h += '<button type="button" class="tt-quiz__opt' + (pics ? ' has-pic' : '') + (answers[i] === o.id ? ' is-on' : '') + '" data-a="' + esc(o.id) + '">' + pic + '<span class="tt-quiz__opt-txt">' + esc(o.label) + '<span aria-hidden="true">→</span></span></button>';
    });
    if (Q[i + 1]) Q[i + 1].a.forEach(function (o) { if (o.img) { var im = new Image(); im.decoding = 'async'; im.sizes = window.innerWidth >= 750 ? '240px' : '112px'; im.srcset = o.set || ''; im.src = o.img; } });
    h += '</div><div class="tt-quiz__nav">';
    if (i > 0) h += '<button type="button" class="tt-quiz__back" data-back>← Back</button>';
    h += '<a class="tt-quiz__skip" href="' + esc(D.allUrl) + '">See all ' + boats.length + ' boats</a></div></div>';
    stage.innerHTML = h;
  }

  function card(b, a, rank) {
    var best = rank === 1;
    var r = reasons(b, a);
    var h = '<article class="tt-quiz__boat' + (best ? ' is-best' : '') + '">';
    h += '<a class="tt-quiz__pic' + (b.cut ? ' is-cut' : '') + '" href="' + esc(b.url) + '" style="--ft: ' + b.ft + '">' + (b.img ? '<img src="' + esc(b.img) + '" alt="' + esc(b.name) + '" loading="lazy">' : '<span class="tt-missing">No product photo on ' + esc(b.handle) + '.</span>') + '</a>';
    h += '<div class="tt-quiz__info"><span class="tt-quiz__tag">' + (best ? 'Best match' : 'No. ' + rank) + '</span>';
    h += '<h3 class="tt-quiz__name">' + esc(b.name) + '</h3><p class="tt-quiz__line">' + esc(b.line) + '</p>';
    if (r.length) { h += '<ul class="tt-quiz__why">'; r.forEach(function (t) { h += '<li>' + esc(t) + '</li>'; }); h += '</ul>'; }
    h += '<dl class="tt-quiz__prices">';
    if (b.hull) h += '<div><dt>' + esc(D.priceWord) + (b.with1 ? (b.build === 'air' ? ', kayak only' : ', hull only') : '') + '</dt><dd>' + esc(b.hull) + '</dd></div>';
    else h += '<div><dt>' + esc(D.priceWord) + '</dt><dd><span class="tt-missing">No price on ' + esc(b.handle) + '.</span></dd></div>';
    if (b.with1) h += '<div><dt>With drive</dt><dd>' + esc(b.with1) + '</dd></div>';
    if (b.with2) h += '<div><dt>With two drives</dt><dd>' + esc(b.with2) + '</dd></div>';
    h += '</dl><div class="tt-quiz__ctas"><a class="tt-btn tt-quiz__cta" href="' + esc(b.url) + '">View boat</a>';
    h += '<a class="tt-btn tt-btn--secondary" href="' + esc(D.dealerUrl) + '">Find a dealer</a></div></div></article>';
    return h;
  }

  function renderResult() {
    var a = {};
    Q.forEach(function (q, i) { a[q.id] = answers[i]; });
    var ranked = boats.map(function (b, i) { return { b: b, s: score(b, a), i: i }; })
      .sort(function (x, y) { return y.s - x.s || x.i - y.i; });
    var h = '<div class="tt-quiz__result">' + dots(Q.length);
    // RANKED, THREE UP, THEN A SWIPE (Josh, 2026-10-20: "3 options ... or maybe more in a slider
    // ranked"). Only boats that can meet every answer that rules one out make the row (a large
    // negative is a fit it cannot meet), and never fewer than three.
    var fits = ranked.filter(function (r, i) { return i < 3 || r.s > NO / 2; });
    h += '<div class="tt-quiz__rhead"><h2 class="tt-quiz__ask" tabindex="-1" data-quiz-focus>Your top matches</h2>';
    if (fits.length > 3) h += '<div class="tt-quiz__arrows"><button type="button" class="tt-quiz__arrow" data-slide="-1" aria-label="Previous boats">←</button><button type="button" class="tt-quiz__arrow" data-slide="1" aria-label="More boats">→</button></div>';
    h += '</div>';
    h += '<p class="tt-quiz__sum">';
    h += Q.map(function (q, i) { var o = q.a.filter(function (x) { return x.id === answers[i]; })[0]; return esc(o ? o.label : ''); }).join(' <span aria-hidden="true">·</span> ');
    h += '</p><div class="tt-quiz__boats" data-quiz-row>' + fits.map(function (r, i) { return card(r.b, a, i + 1); }).join('') + '</div>';
    if (fits.length > 3) h += '<p class="tt-quiz__more">' + (fits.length - 3) + ' more that could work: swipe or use the arrows.</p>';
    h += '<div class="tt-quiz__nav"><button type="button" class="tt-quiz__back" data-back>← Back</button><button type="button" class="tt-quiz__back" data-restart>Start over</button>';
    h += '<a class="tt-quiz__skip" href="' + esc(D.allUrl) + '">See all ' + boats.length + ' boats</a></div></div>';
    stage.innerHTML = h;
  }

  stage.addEventListener('click', function (e) {
    var opt = e.target.closest('[data-a]');
    if (opt) { go(answers.concat(opt.getAttribute('data-a'))); return; }
    if (e.target.closest('[data-back]')) { go(answers.slice(0, -1)); return; }
    if (e.target.closest('[data-restart]')) { go([]); return; }
    var arrow = e.target.closest('[data-slide]');
    if (arrow) {
      var row = stage.querySelector('[data-quiz-row]');
      var step = row.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(row).columnGap || 0);
      row.scrollBy({ left: step * Number(arrow.getAttribute('data-slide')), behavior: 'smooth' });
    }
  });
  window.addEventListener('popstate', function () { answers = readHash(); render(true); });

  answers = readHash();
  render(false);
})();
